export const configFetching= 'FETCHING_CONFIG'
export const configFetched= 'FETCHED_CONFIG'
export const configError= 'ERROR_CONFIG'
export const updateExperiments= '[CONFIG] UPDATE_EXPERIMENTS'
